var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1724 5.22225L13.9652 11.3027L16.4588 11.8236L15.5668 5.26977L14.1724 5.22225ZM3.6386 4.85969L3.39952 11.8756L1.39225 11.8072L2.07794 4.8065L3.6386 4.85969ZM4.16781 11.3999L4.38131 5.13474C5.13659 5.07643 6.70541 4.71205 6.94099 3.71749C7.1754 2.7217 8.23733 2.50694 8.73975 2.52406L8.40675 12.296L4.16785 11.3987L4.16781 11.3999ZM13.2163 11.2076L13.4128 5.44251C12.6632 5.33292 11.1216 4.86254 10.9556 3.8531C10.7895 2.84366 9.74342 2.55707 9.24221 2.53999L8.92621 11.813L13.2164 11.2064L13.2163 11.2076Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarTextIcon);
export default __webpack_public_path__ + "static/media/sideBarTextIcon.42007c0460d2db5c32255c18dacdf394.svg";
export { ForwardRef as ReactComponent };